import { useState } from "react";
import { Loader2, ImageDown, Share2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { renderBoardImage } from "@/lib/boardGrid";

export const BoardShareImage = ({ link }) => {
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [blob, setBlob] = useState(null);

  const make = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/squares/board");
      const b = await renderBoardImage(data, link.replace(/^https?:\/\//, ""));
      setBlob(b);
      setPreview(URL.createObjectURL(b));
    } catch { toast.error("Could not build the board image"); }
    setBusy(false);
  };

  const share = async () => {
    const file = new File([blob], "iron-bowl-board.png", { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], text: `Grab your square on the Iron Bowl Board! ${link}` }); } catch { /* cancelled */ }
      return;
    }
    const a = document.createElement("a");
    a.href = preview; a.download = "iron-bowl-board.png"; a.click();
    toast.success("Image saved, post it with your link");
  };

  return (
    <div className="space-y-3" data-testid="board-share-image">
      {!preview ? (
        <button onClick={make} disabled={busy} className="btn-gold rounded-full px-5 py-2.5 font-display uppercase tracking-wide text-sm inline-flex items-center gap-2 disabled:opacity-60" data-testid="board-share-make">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <ImageDown size={16} />} Make Board Image
        </button>
      ) : (
        <>
          <img src={preview} alt="Live square board" className="w-full max-w-xs mx-auto rounded-xl border border-[#d4af37]/30" data-testid="board-share-preview" />
          <div className="flex gap-2 justify-center flex-wrap">
            <button onClick={share} className="btn-gold rounded-full px-5 py-2.5 font-display uppercase tracking-wide text-sm inline-flex items-center gap-2" data-testid="board-share-post"><Share2 size={16} /> Share / Save Image</button>
            <button onClick={make} disabled={busy} className="btn-outline-cream rounded-full px-5 py-2.5 font-display uppercase tracking-wide text-sm" data-testid="board-share-refresh">Refresh</button>
          </div>
          <p className="text-[#8f857a] text-xs text-center">Post it on Facebook or Instagram. Paste your link in the caption or bio.</p>
        </>
      )}
    </div>
  );
};
